<template>
  <div class="has_market_price">
    <!-- Header Included here -->
    <Header />
    <nav class="navbar navbar-light navbar-expand-md">
      <div class="container-fluid">
        <div class="container justify-content-center">
          <ul class="nav navbar-nav navcol-1">
            <li class="nav-item" role="presentation">
              <router-link class="nav-link active" to="#"
                >Partnership</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="terms-of-use"
                >Terms of use</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="terms-of-sale"
                >Terms of Sale</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="/privacy-policy"
                >Privacy Policy</router-link
              >
            </li>
            <li class="nav-item" role="presentation">
              <router-link class="nav-link" to="/faqs">FAQs</router-link>
            </li>
          </ul>
        </div>
        <a class="navbar-brand" href="#"></a>
      </div>
    </nav>

    <div class="container no_scroll">
      <div class="row my-3 no_scroll">
        <div class="col-lg-9 mx-auto px-0 no_scroll">
          <div class="pr-4 pt-2 text-justify no_scroll">
            <h5 class="mb-4 ml-2">Terms of Use</h5>
            <p class="ml-2">
              Welcome to Quick Leap (the “Platform”), an impact driven
              aggregated B2B market place that connects farmers to markets,
              enables trades, and supplies businesses the raw material demand
              for inventory all year round, while providing sponsorship
              opportunities. This Platform is brought to you by Quick Leap
              global Limited (“QuickLeap”, “we”, “us”, or “our”).
            </p>

            <ol>
              <li>
                <h6 class="text-black font-weight-bold">Consent</h6>
                This Terms of Use constitutes a legally binding contract between
                you, (whether as a guest or registered user) and Quick Leap in
                your access and use of the Platform as well as its content,
                services and functionality made available on or through the
                Platform (collectively referred to as “the Services”). We
                therefore kindly request that you carefully read through these
                Terms and Conditions of Use (the “Terms of Use” or “User
                Agreement”) before using the Platform and click on the Agree
                icon if you consent and agree to be bound by
                <ul class="list-none">
                  <li>this Terms of Use and</li>
                  <li>
                    the Privacy Policy (“the Policy”). By using the Platform,
                    you accept the terms and conditions contained on this
                    Platform, which shall govern your use of this Platform,
                    including all pages or links on the Platform. If you do not
                    agree to these Terms of Use or the Privacy Policy, please do
                    not use the Platform and/or the Services and exit
                    immediately. In addition, if you do not agree to these Terms
                    of Use, Term of sale, or the Policy, you agree that your
                    sole and exclusive remedy is to discontinue using this
                    Platform. That notwithstanding, if you proceed to browsing,
                    accessing, or otherwise using the Services in any manner, it
                    will be deemed that you have accepted, without limitation or
                    qualification, both the Terms of Use and the Privacy Policy
                    for the Platform (the “Policy”).
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Review of Terms of Use
                </h6>
                We may, at our sole discretion, review, revise and/or update
                this Terms of Use and the Platform at any time. We therefore
                advise that you read through this Terms of Use periodically. You
                further agree that we will have no further obligation to notify
                you of any modifications and such updates or modifications shall
                become effective immediately upon the posting thereof or on any
                specified date. The most current version of the Terms of Use can
                be accessed at any time by selecting Terms of Use link on the
                bottom of the home page for the Platform.
              </li>

              <li>
                <h6 class="text-black font-weight-bold">Age</h6>
                You must be at least 18 (eighteen) years old to use our Platform
                or any of our Services; by using our Platform or agreeing to
                these terms and conditions, you represent and warrant to us that
                you are at least 18 years of age. Individuals under the age of
                18, or applicable age of maturity, may utilize our Services only
                with involvement of a parent or legal guardian, under such
                person’s account.
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Security of Password
                </h6>
                To fully enjoy our Services, you may be required to create an
                account and in which case you will be given (or you may provide)
                a username and password. Certain areas of our Services are only
                accessible with the use of username and passwords (“User
                Restricted Areas”). Please note that you are fully and solely
                responsible for any and all use of the Services and such, you
                are required to keep your password secret at all times. Do not
                share your password with any third party or allow another person
                to access the User Restricted Areas using your password. Kindly
                notify us immediately if you have any reason to believe that
                your username or password has been lost or compromised or
                misused in any way. Also immediately report any unauthorized or
                suspicious activity in your account.
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Available Content and Use
                </h6>
                <ul>
                  <li>
                    <strong>Content Description:</strong> The Platform contains
                    variety of contents, including but not limited to text,
                    data, files, documents, software, scripts, layout, design,
                    function, aesthetics, graphics, images, audio, videos,
                    audiovisual combinations, interactive features and any other
                    materials that you may view, access or download (but only as
                    expressly permitted in paragraph C below) on the Platform.
                  </li>

                  <li>
                    <strong>Proprietary Rights:</strong> All the contents of the
                    Platform, whether publicly posted or privately transmitted,
                    as well as all derivative works thereof, are owned by Quick
                    Leap, its affiliates and where applicable, to third parties
                    who have licensed such rights to Quick Leap Global
                    (“Licensors”). Hence, the Platform is protected by
                    copyright, trademark, and other applicable intellectual
                    property rights/laws. Except as specifically permitted
                    herein, you shall not copy, reproduce, republish, upload,
                    post, transmit, modify or distribute the Platform or any
                    part of it in any way, including by e-mail or other
                    electronic means, without the prior consent of Quick Leap or
                    its Licensors.
                  </li>

                  <li>
                    <strong>Restrictions on use of the Platform:</strong> Please
                    note that the contents of this Platform are solely for your
                    information and personal use, as intended through the
                    provided functionality of the Services and permitted under
                    this User Agreement. As such, you:
                    <ul>
                      <li>
                        are prohibited from modifying or using the Content on
                        any web Platform or networked computer environment or
                        using the Content for any purpose other than personal,
                        non-commercial use, without the consent of Quick Leap
                        Global or its licensors first had and obtained, where
                        applicable. Such use or modification is a violation of
                        the copyright, trademark, and other proprietary rights
                        in the Content.
                      </li>
                      <li>
                        shall not use our Platform in any way or take any action
                        that causes or may cause damage to the Platform or
                        impairment of the performance, availability or
                        accessibility of the Platform; iii. shall not use our
                        Platform in any way that is unlawful, illegal,
                        fraudulent or harmful, or in connection with any
                        unlawful, illegal, fraudulent or harmful purpose or
                        activity or in any way that breaches any applicable law
                        or regulations;
                      </li>
                      <li>
                        shall not circumvent, disable or otherwise interfere
                        with security-related features of the Services;
                        including security features that prevent or restrict the
                        use or copying of any content.
                      </li>
                      <li>
                        shall not use data collected from our Platform for any
                        direct marketing activity (including without limitation
                        email marketing, SMS marketing, telemarketing or direct
                        mailing).
                        <br />&nbsp; vi. shall not alter, remove, or falsify any
                        attributions or other proprietary designations of origin
                        or source of any Content appearing on the Platform.
                      </li>
                      <li>
                        Shall not use the Platform in any way to create
                        liability, or in any way that causes us to lose the
                        services of our Internet Service Providers or other
                        suppliers.
                      </li>
                      <li>
                        shall not download any content on the Platform unless
                        you see a “download” or similar link displayed by us on
                        the Platform for such content. You further agree that:
                      </li>
                      <li>
                        you are responsible for your own conduct while using the
                        Platform or Services and for any consequences thereof;
                      </li>
                      <li>
                        You shall use this Platform and all Services on the
                        Platform only for purposes that are legal, proper and in
                        accordance with this Terms of Use, the Privacy Policy,
                        and any applicable law, rules or regulations, any
                        consumer protection, unfair competition, and
                        anti-discrimination laws or regulations and any
                        applicable foreign laws).
                      </li>
                      <li>
                        You are solely responsible for your interactions with
                        other users of the Platform (“Users”) both within the
                        Platform and outside of the Platform. Quick Leap
                        expressly disclaims any responsibility for interactions,
                        loss or liabilities between users or between you and any
                        third party outside of the Platform.
                      </li>
                    </ul>
                  </li>

                  <li>
                    <strong>Disclaimer</strong>
                    <ul>
                      <li>
                        and ‘AS AVAILABLE’ basis. You therefore agree to
                        evaluate, seek independent advice and bear all risks
                        associated with the use of the Platform. Nothing on the
                        Platform should be deemed to constitute a recommendation
                        to purchase, sell or hold, or otherwise to constitute an
                        advice regarding, any investment, secured or otherwise.
                      </li>

                      <li>
                        ii. We will not be liable for any damages (including,
                        without limitation, damages for any consequential loss
                        or loss of business opportunities or projects, or loss
                        of profits) howsoever arising and whether in contract,
                        tort or otherwise from the use of or inability to use
                        our Platform, or any of its contents and materials, or
                        from any action or omission taken as a result of using
                        the Platform or any such contents. In any event, our
                        liability for any and all proven damages or losses shall
                        not in any circumstances exceed the amount paid by you,
                        if any, for accessing this Platform.
                      </li>

                      <li>
                        All liability is excluded to the fullest extent
                        permitted by applicable law including any implied terms
                        as the content of this Platform “as is” without
                        warranties of any kind. We reserve the right to change
                        all the contents of this Platform at any time without
                        notice to you.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">Confidentiality</h6>
                <ul>
                  <li>
                    You undertake that all communication, content, intellectual
                    property or other information, and materials on the
                    Platform, either marked ‘confidential’ or is by its nature
                    intended to be for your knowledge alone, shall be kept
                    confidential unless or until you can reasonably demonstrate
                    that such communication, information and material is, or
                    part of it is, in the public domain through no fault of
                    yours. Furthermore, any communication, content, intellectual
                    property or other information, and materials you obtain in
                    terms of or arising from the use of this Platform shall be
                    treated as confidential and shall not be divulged or
                    permitted to be divulged to third parties, without our prior
                    written consent.
                  </li>
                  <li>
                    Please note that all obligations relating to Confidential
                    Information under this Terms of Use will continue after
                    termination of the Terms of Use and termination of access
                    rights hereunder.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">Use of suggestions</h6>
                You acknowledge and agree that any questions, comments,
                suggestions, ideas, feedback, or other information provided by
                you to Quick Leap (collectively, “Feedback”) are not
                confidential and you hereby grant to Quick Leap a worldwide,
                perpetual, irrevocable, royalty-free license to reproduce,
                display, perform, distribute, publish, modify, edit or otherwise
                use such Feedback as it deems appropriate, for any and all
                commercial or non-commercial purposes, in its sole discretion
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Undertakings You hereby agree as follows:
                </h6>
                <ul>
                  <li>
                    not to access or use the Services in an unlawful way or for
                    an unlawful or illegitimate purpose, including without
                    limitation any violation of any criminal or anti-money
                    laundering laws of the Federal Republic of Nigeria or any
                    other jurisdiction where you are resident;
                  </li>
                  <li>
                    not to post, publish or transmit on the Platform (a) any
                    message or information under a false name; (b) information
                    that is unlawful, malicious, libelous, defamatory, obscene,
                    fraudulent, predatory of minors, harassing, discriminatory,
                    threatening or hateful to any person; or (c) information
                    that infringes or violates any contractual or intellectual
                    property rights of others or the privacy or publicity rights
                    of others
                  </li>
                  <li>
                    not to post, process, publish or transmit any content
                    (including works, data, materials (including without
                    limitation), text, graphics, images, information, audio
                    material, audio-visual material, scripts, software and
                    files) that is illegal or unlawful; or infringe any person’s
                    legal rights; or capable of giving rise to legal action
                    against us or any person (in any jurisdiction and under any
                    applicable law).
                  </li>
                  <li>
                    not to transmit, distribute, introduce or otherwise make
                    available in any manner through the Services any computer
                    virus, keyloggers, malware, spyware, worms, Trojan horses,
                    time bombs or other malicious or harmful code (collectively,
                    “Harmful Code”) or to do any act capable of disrupting the
                    operation of the Platform; Please note that we do not have
                    an obligation to detect the presence of Harmful Code (as
                    defined in “Restrictions on the use of your Services” below.
                    Please note that if you download any Content from the
                    Platform, you do so at your own risk
                  </li>
                  <li>
                    not to use the Platform in any manner that could damage,
                    disable or impair our services or networks;
                  </li>
                  <li>
                    not to attempt to gain unauthorized access to the Platform
                    or any user accounts or computer systems or networks,
                    through hacking, password mining or any other unlawful
                    means;
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Intellectual Property
                </h6>
                <ol>
                  <li>
                    Quick Leap shall remain the owner of the know-how,
                    trademarks, service marks, logos, slogans, patents,
                    copyright or other intellectual property rights belonging to
                    it within or outside the Platform. The use of the Platform,
                    and nothing contained herein shall create nor transfer any
                    intellectual property right belonging to Quick Leap, and you
                    are not allowed to use any such rights belonging to Quick
                    Leap without our written consent
                  </li>
                  <li>
                    If you believe that any content on the Platform infringes
                    upon your copyrights, please contact us through the contact
                    details below.
                  </li>
                </ol>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Financial Partners At Quick Leap
                </h6>
                We partner with other financial/payment service providers in
                providing our Services to you. In order to enable you make
                payments on/through the Platform, we may share your information
                with these financial partners. You therefore authorize us to
                share your identity and banking information with partner
                financial institutions in respect of our Services. Quick Leap
                shall not be liable for any default, negligence or breach of the
                financial partners
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Termination/Suspension
                </h6>
                <ul>
                  <li>
                    In the event of any breach of this Terms of Use, Quick Leap
                    shall have the right to suspend or terminate all or a
                    portion of the Services to you in our discretion, or
                    restrict your access to the Platform. We reserve the right
                    to revoke, terminate or suspend any privileges associated
                    with accessing the Services for any reason (including
                    regulatory instruction) or for no reason whatsoever. You
                    agree that Quick Leap shall not be liable to you or any
                    third party for any termination or suspension of your access
                    to the Platform.
                  </li>
                  <li>
                    Termination of your access to the Platform shall be without
                    prejudice to any payment or sum due to you as at the date of
                    termination or suspension of your account. Provided that if
                    the termination or suspension of your account was a result
                    of your breach of this Terms of Use which resulted in any
                    loss, penalty or damage to Quick Leap, we shall be entitled
                    to set off such loss from any sum due to you. You shall be
                    notified of the extent of the loss caused as a result of
                    your breach (where quantifiable) and the extent of the set
                    off applied to any sum due to you from Quick Leap. Any
                    balance after the set off shall be remitted to you.
                  </li>
                  <li>
                    If you wish to close your account, you may do so by
                    contacting Quick Leap’s customer service through the contact
                    details below. In the event of an abrupt request closure of
                    your account before the end of a sale, trade, purchase or
                    sponsorship cycle, Quick Leap shall be at liberty to charge
                    or deduct any assessed charges, processing charge, costs,
                    taxes and any assessed damages (where applicable) prior to
                    the refund of any sum due to you. Unless otherwise specified
                    and agreed, you shall remain obligated to pay all
                    outstanding charges, if any, relating to your use of the
                    Platform prior to such closure request.
                  </li>
                  <li>
                    C above will be verified in detail and where verifications
                    have been completed, payments containing or void of
                    deductible amount would be made. Questions on payments and
                    other related financials should be directed to
                    <a href="mailto:payments@quickleapglobal.com"
                      >payments@quickleapglobal.com.</a
                    >
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Links to other Platforms
                </h6>
                The Platform contain links to other platforms/websites or
                resources on the internet. When you access third party
                platforms/websites, you do so at your own risk. Links to other
                platforms/websites do not constitute an endorsement, control,
                guarantee, authorization or representation of our affiliation
                with those third parties. Kindly note that this Terms of Use or
                our Privacy Policy do not apply to those third-party Platforms,
                as such, you agree that Quick Leap shall not be liable under any
                circumstances in relation to your use of such other
                platforms/websites.
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  No financial, investment or sponsorship advice
                </h6>
                <ul>
                  <li>
                    This Platform provides preliminary and general information
                    about trade, products available, and investment
                    opportunities and is intended for initial reference purposes
                    only. Nothing on the Platform should be interpreted as
                    providing or intending to provide financial or investment
                    advice. You acknowledge that Quick Leap has not provided any
                    financial, investment, legal or tax advice and/or any other
                    advice of any kind. You further agree that your use of the
                    Platform or any of the Services on the Platform is based on
                    your careful consideration, due diligence and/or based on
                    the independent advice sought from your advisors
                  </li>
                  <li>
                    Any questions regarding anything on the Platform should be
                    addressed to Quick Leap using the contact information set
                    below. Where Quick Leap publishes information from
                    independent or third-party sources (including without
                    limitation, newspapers, magazines and the internet) such
                    publication is for informational purposes, without more.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Disclaimer of Warranty
                </h6>
                <ul>
                  <li>
                    The Platform, its content and all services on the platform
                    are provided “as is” and “as available” without any warranty
                    of any kind, express or implied. To the fullest extent
                    permissible pursuant to applicable law, Quick Leap, its
                    affiliates and any person associated with Quick Leap and its
                    affiliates, disclaims all warranties of any kind, either
                    express or implied, statutory or otherwise, including but
                    not limited to any implied warranties of title,
                    merchantability, fitness for a particular purpose or
                    non-infringement.
                  </li>
                  <li>
                    Without limiting the foregoing, Quick Leap does not warrant
                    that access to the Platform will be uninterrupted or
                    error-free, or that defects, if any, will be corrected
                    within any specific timeframe; nor does Quick Leap, its
                    affiliates, nor any person associated with Quick Leap make
                    any representations about the accuracy, standard, currency,
                    completeness, usefulness, performance, security, or
                    suitability of the Platform. Quick Leap does not warrant
                    that the Platform is free of viruses or other harmful
                    components. You shall be solely and fully responsible for
                    any damage to any computer system, any loss of data, or any
                    improper use or improper disclosure of information caused by
                    you or any person using your login credentials. Quick Leap
                    cannot and does not assume any responsibility for any loss,
                    damages or liabilities arising from the failure of any
                    telecommunications infrastructure, or the internet or for
                    your misuse of any of advice, ideas, information,
                    instructions or guidelines accessed through the Services. It
                    is your responsibility to install or download sufficient
                    software or hardware protection for your device or computer.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Limitation of liability
                </h6>
                <ul>
                  <li>
                    Quick Leap and its subsidiaries, affiliates, officers,
                    directors, agents or employees are not liable to you or any
                    other person for any punitive, exemplary, consequential,
                    incidental, indirect or special damages (including, without
                    limitation, any personal injury, lost profits, business
                    interruption, loss of programs or other data on your
                    computer or otherwise) arising from or in connection with
                    your use of the Platform, whether under a theory of breach
                    of contract, tort, negligence, strict liability,
                    malpractice, any other legal or equitable theory or
                    otherwise, even if Quick Leap has been advised of the
                    possibility of such damages. You hereby release Quick Leap
                    and hold it and its parents, subsidiaries, affiliates,
                    officers, directors, agents and employees harmless from any
                    and all claims, demands, and damages of every kind and
                    nature (including, without limitation, actual, special,
                    incidental and consequential), known and unknown, suspected
                    and unsuspected, disclosed and undisclosed, arising out of
                    or in any way connected with your use of the Services. You
                    waive the provisions of any state or local law limiting or
                    prohibiting a general release.
                  </li>
                  <li>
                    The foregoing limitation of liability shall apply to the
                    fullest extent permitted by law in the applicable
                    jurisdiction. This limitation of liability also applies with
                    respect to damages incurred by you by reason of any products
                    or services sold or provided on any linked Platforms or
                    otherwise by third parties other than Quick Leap and
                    received through the Services or any linked Platforms.
                  </li>
                  <li>
                    Without prejudice to the limitation of liability above, in
                    the event of any problem with the Platform or any of the
                    services on the Platform, you agree that your final,sole and
                    exclusive remedy is to cease using the Platform. Under no
                    circumstances shall Quick Leap, its subsidiaries,
                    affiliates, officers, directors, agents or employees be
                    liable in any way for your use of Services, including, but
                    not limited to, any errors or omissions in the Platform,
                    downtime, any infringement by the Platform of the
                    intellectual property rights or other rights of third
                    parties, or for any loss or damage of any kind incurred as a
                    result of the use of the Services.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Breaches of Terms and Conditions
                </h6>
                <ul>
                  <li>
                    Without prejudice to our other rights under these terms and
                    conditions, if you breach these terms and conditions in any
                    way, or if we reasonably suspect that you have breached
                    these terms and conditions in any way, we shall:
                    <br />&nbsp; i. send you one or more formal warnings in
                    writing to this effect; <br />&nbsp; ii. temporarily suspend
                    your access to our Platform; <br />&nbsp; iii. permanently
                    prohibit you from accessing our Platform; <br />&nbsp; iv.
                    block your access to the Platform; <br />&nbsp; v. commence
                    legal action against you, whether for breach of contract or
                    otherwise; and/or <br />&nbsp; vi. suspend or delete your
                    account on our Platform.
                    <br />
                  </li>
                  <li>
                    Where we suspend or prohibit or block your access to our
                    Platform or a part of our Platform, you must not take any
                    action to circumvent such suspension or prohibition or
                    blocking (including without limitation, creating and/or
                    using a different account).
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">Indemnification</h6>
                <ul>
                  <li>
                    Without limiting the generality or effect of other
                    provisions of this Terms of Use, you agree to indemnify,
                    hold harmless, and defend Quick Leap and its subsidiaries,
                    affiliates, officers, directors, affiliates, agents and
                    employees, parent companies, (collectively, “Indemnified
                    Parties” and each, individually, an “Indemnified Party”)
                    against all costs, expenses, liabilities and damages
                    (including reasonable attorney’s fees) incurred by any
                    Indemnified Party in connection with any third party claims
                    arising out of: (i) your use of the Platform or any part of
                    it; (ii) your failure to comply with any applicable laws and
                    regulations; and (iii) your breach of any obligations set
                    forth in this Terms of Use
                  </li>
                  <li>
                    This indemnity obligation shall survive this Terms of Use
                    and your use of the Platform. Quick Leap reserves the right
                    to assume the exclusive defense and control of any matter
                    otherwise subject to indemnification by you, in which event
                    you will assist and cooperate with Quick Leap in asserting
                    any available defenses.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Governing law and dispute resolution
                </h6>
                <ul>
                  <li>
                    This Terms of Use and all disputes and matters arising from
                    the Platform (or its use) shall be governed by the laws of
                    the Federal Republic of Nigeria.
                  </li>
                  <li>
                    In the event of a controversy, claim or dispute arising out
                    of or relating to this Terms of Use, the Parties shall
                    attempt in good faith to resolve such controversy, claim or
                    dispute promptly by negotiation between the parties or their
                    authorized representatives. You shall, before exploring any
                    other remedy in law, notify Quick Leap of the dispute or
                    complaint through the contact details below. If parties are
                    unable to resolve the controversy, claim or dispute, the
                    parties shall be at liberty to explore any other dispute
                    resolution mechanism known to Law including mediation,
                    arbitration or litigation.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">Miscellaneous</h6>
                <ul>
                  <li>
                    <strong>Entire Agreement:</strong> This User Agreement
                    constitutes the sole agreement between you and Quick Leap
                    for your use and the provision of the Services and the
                    subject matter hereof, and no representations, statements or
                    inducements, oral or written, not contained in this Terms of
                    Use shall bind either you or Quick Leap.
                  </li>
                  <li>
                    <strong>Severance:</strong> If any provision of this Terms
                    of Use is prohibited by law or judged by a court to be
                    unlawful, void or unenforceable, the provision shall, to the
                    extent required, be severed from this Terms of Use and
                    rendered ineffective as far as possible without modifying
                    the remaining provisions of this Terms of Use, and shall not
                    in any way affect any other circumstances of or the validity
                    or enforcement of this Terms of Use.
                  </li>
                  <li>
                    <strong>Waiver:</strong>Failure to insist on performance of
                    any of the terms of this Terms of Use will not operate as a
                    waiver of any subsequent default. No waiver by Quick Leap of
                    any right under this Terms of Use will be deemed to be
                    either a waiver of any other right or provision or a waiver
                    of that same right or provision at any other time.
                  </li>
                  <li>
                    <strong>Assignment:</strong>You may not assign, transfer or
                    delegate your rights or obligations hereunder, in whole or
                    in part.
                  </li>
                  <li>
                    <strong>Bindingness:</strong>This Terms of Use shall be
                    binding upon and inure to the benefit of each of the parties
                    and the parties’ respective successors and permitted
                    assigns. A printed version of this Terms of Use and of any
                    related notice given in electronic form shall be admissible
                    in judicial or administrative proceedings based upon or
                    relating to this Terms of Use to the same extent and subject
                    to the same conditions as other business documents and
                    records originally generated and maintained in printed form.
                  </li>
                </ul>
              </li>

              <li>
                <h6 class="text-black font-weight-bold">
                  Notice/Contact Details
                </h6>
                In the case of any complaints or notice of dispute or any other
                notification, please contact us at:
                <br />

                <div class="alert alert-warning">
                  <b>Quick Leap Global Limited</b>
                  <br />No 3 B Ayinde, Sanni Close, <br />Oregun, Ikeja,
                  <br />Lagos, Nigeria.
                  <br />
                  <a href="mailto:hello@quickleapglobal.com"
                    >hello@quickleapglobal.com</a
                  >
                  <br />
                  <a href="tel:08134860483">+234 (0) 813 486 0483</a>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <market-price />
  </div>
</template>

<script>
// import Header from "@/components/Header.vue";
import MarketPrice from "@/components/MarketPrice.vue";
import Header from "@/components/Header.vue";

export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Legal",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { Header, MarketPrice }
};
</script>

<style scoped>
ol,
ul {
  padding-inline-start: 20px;
}
ol li {
  margin: 10px 0;
}
ul li {
  margin: 5px 0;
}
.nav-item {
  width: 150px !important;
  height: 40px !important;
  background: #000;
  border-radius: 210px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 576px) {
  .nav-item {
    width: 80px !important;
    height: 30px !important;
    margin-bottom: 5px !important;
  }
  .no_scroll {
    overflow: hidden !important;
    padding: auto auto auto 10px !important;
  }
  .navcol-1 {
    width: 100% !important;
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
    margin-bottom: 0px !important;
    position: relative !important;
  }
  .nav-link {
    font-weight: 300;
    font-size: 10px !important;
    line-height: 14px;
  }
}
.nav-link {
  color: #fff !important;
  text-align: center;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 28px;
}
</style>
